const filterRelatedContentCards = (textSets, articles) => {
  const atLeastTwoTextSets = textSets.length >= 2;
  const atLeastTwoArticles = articles.length >= 2;
  const lessThanTwoTextSets = textSets.length < 2;
  const lessThanTwoArticles = articles.length < 2;

  if (atLeastTwoTextSets && atLeastTwoArticles) {
    return articles.slice(0, 2).concat(textSets.slice(0, 2));
  } else if (lessThanTwoTextSets && atLeastTwoArticles) {
    return textSets.concat(articles.slice(0, 4 - textSets.length));
  } else if (lessThanTwoArticles && atLeastTwoTextSets) {
    return articles.concat(textSets.slice(0, 4 - articles.length));
  } else {
    return articles.concat(textSets);
  }
};

export default filterRelatedContentCards;
